
const allNotification = { data: [], loading: true };


export const GetAllNotification = (state = allNotification, action) => {
    switch (action.type) {

        case "get_allNotification":
            return {
                data: action.payload,
                loading: action.loading
            }
        default:
            return state;
    }


}